module.exports = __webpack_public_path__ + "img/spawner-die-03.5fe101d0.png";